import * as React from "react";
import { Typography, Box, Container, Grid } from "@mui/material";
import { useTheme } from "@mui/system";
import cost from "../assets/cost.png";
import outsource from "../assets/outsource.png";
import multital from "../assets/multital.jpg";
import flexible from "../assets/flexible.png";

const userTestimonials = [
  {
    image: cost,
    name: "Cost effective and cost efficient",
    testimonial:
      "We offer our clients cost effective solutions that meet their needs using a number of approaches.",
  },
  {
    image: outsource,
    name: "Responsible outsourcing",
    testimonial:
      "We have consistently delivered on our promise adhering to the best industry practices.",
  },
  {
    image: multital,
    name: "Multi talented",
    testimonial:
      "Unlike in big, super structured companies, we change roles and have fun further developing our potential.",
  },
  {
    image: flexible,
    name: "Flexible",
    testimonial:
      "We support individual’s work preferences, resulting in better motivated staff who want to stay in the job.",
  },
];

export default function Testimonials() {
  const theme = useTheme();

  return (
    <Container
      id="testimonials"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: 3, sm: 6 },
      }}
    >
      <Box
        sx={{
          width: { sm: "100%", md: "60%" },
          textAlign: { sm: "left", md: "center" },
        }}
      >
        <Typography component="h2" variant="h4" gutterBottom>
          Why Choose Us?
        </Typography>
        <Typography variant="body1">
          See what our customers love about our products. Discover how we excel
          in efficiency, durability, and satisfaction. Join us for quality,
          innovation, and reliable support.
        </Typography>
      </Box>
      <Grid container spacing={4}>
        {userTestimonials.map((testimonial, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Box
              sx={{
                p: 4,
                backgroundColor: "background.paper",
                borderRadius: "12px",
                boxShadow: 3,
                transition: "transform 0.3s ease-in-out",
                "&:hover": { transform: "scale(1.02)" },
              }}
            >
              <Typography variant="body1" gutterBottom>
                {testimonial.testimonial}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mt: 2,
                }}
              >
                <Box
                  component="img"
                  src={testimonial.image}
                  alt={testimonial.name}
                  sx={{
                    width: 50,
                    height: 50,
                    borderRadius: "8px",
                    objectFit: "cover",
                    mr: 2,
                  }}
                />
                <Typography variant="subtitle1" fontWeight="bold">
                  {testimonial.name}
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
